import { jsx as a } from "react/jsx-runtime";
import o from "./index.es5581.js";
import m from "classnames";
const l = ({ children: r, isHorizontal: s }) => {
  const t = m(o.container, {
    [o.isHorizontal]: s
  });
  return /* @__PURE__ */ a("div", { className: t, children: r });
};
export {
  l as CalloutGroup
};
//# sourceMappingURL=index.es659.js.map
